<template>
  <div
    class="column">
    <div
      class="team-wrap tooltip is-tooltip-top"
      data-tooltip="Click to view resume"
      @click="openModal()">
      <div class="title-wrap">
        <div class="resume-img"/>
        <h3>{{ name }}</h3>
      </div>
    </div>
    <div
      :class="{ 'is-active': open}"
      class="modal">
      <div
        class="modal-background"
        @click="closeModal()"/>
      <div class="modal-content">
        <div class="title-area-in-content">
          <h3>{{ name }}</h3>
          <div
            class="team-details"
            v-html="details"/>
        </div>
      </div>
      <button
        class="modal-close is-large" 
        aria-label="close"
        @click="closeModal()"/>
    </div>
  </div>
</template>

<script>
import 'bulma-tooltip'
export default {
	props: {
		name: {
			type: [String],
			default: ''
		},
		details: {
			type: [String],
			default: 'Default message'
		},
	},
	data() {
		return {
			open: false
		}
	},
	mounted() {
	},
	methods: {
		openModal() {
			this.open = true
			document.getElementById('app').style['will-change'] = 'initial'
			document.addEventListener('keyup', this.handleKeyups)
		},
		closeModal() {
			this.open = false
			document.getElementById('app').style['will-change'] = 'transform'
			document.removeEventListener('keyup', this.handleKeyups)
		},
		handleKeyups(event) {
			27 === event.keyCode && this.closeModal() // ESC
		},
	}
}
</script>

<style lang="scss">
	.team-area {
		flex-wrap: wrap;
		margin-bottom: 2rem!important;
	}
	.team-wrap {
		background: white;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		cursor: pointer;
		// &:hover {
			// box-shadow: 0 0 5px 0px #aaa;
		// }
	}
	.title-wrap {
    padding: 1rem 0;
    text-align: center;
		h3 {
			font-size: 1.2em;
      margin-bottom: 0;
      margin-top: 0.8em !important;
    }
    &:hover {
      background-color: #f0f0f0;
    }
	}

	.modal-background {
		background-color: rgba(black, 0.5)
	}
	.title-area-in-content {
		h3 {
      font-size: 1.4em;
      border-bottom: 1px solid;
      padding-bottom: 0.5em;
      margin-bottom: 1.5em;
		}
	}
	.team-details {
		line-height: 1.7;
	}
	.tooltip.is-tooltip-active::before,
	.tooltip:hover::before {
		background: #E25320;
		font-weight: 600;
		font-size: 1em;
	}
	.tooltip.is-tooltip-active:not(.is-loading)::after, .tooltip:focus:not(.is-loading)::after, .tooltip:hover:not(.is-loading)::after {
		border-color: #E25320 transparent transparent transparent;
	}
	@media only screen and (max-width: 1024px) {
		.tooltip {
			&:before,
			&:after {
				content: none !important;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// assets/js/Resume.vue